/**
 * @generated SignedSource<<49d25be25af88fb08f82defe4112599d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FieldDetailsLabelsFragment$data = {
  readonly labels: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly text: string;
      } | null;
    } | null>;
  } | null;
  readonly " $fragmentType": "FieldDetailsLabelsFragment";
};
export type FieldDetailsLabelsFragment$key = {
  readonly " $data"?: FieldDetailsLabelsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"FieldDetailsLabelsFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FieldDetailsLabelsFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "LabelNodeConnection",
      "kind": "LinkedField",
      "name": "labels",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "LabelNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "LabelNode",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "text",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "FieldNode",
  "abstractKey": null
};

(node as any).hash = "51b232bcc7daa4cfe9ee63a6ea6f364e";

export default node;
